import { useLocation } from "react-router-dom";
import { useEffect } from "react";

function usePageView() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
}

export default usePageView;
